import { render, staticRenderFns } from "./item-card.vue?vue&type=template&id=4e1ee6fd&scoped=true&lang=pug&"
import script from "./item-card.vue?vue&type=script&lang=js&"
export * from "./item-card.vue?vue&type=script&lang=js&"
import style0 from "./item-card.vue?vue&type=style&index=0&id=4e1ee6fd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1ee6fd",
  null
  
)

export default component.exports